module.exports = __webpack_public_path__ + "assets/img/About-Us@2x.dc9bc752.png";